import script from "./AnimationControlsV2.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationControlsV2.vue?vue&type=script&setup=true&lang=js"

import "./AnimationControlsV2.vue?vue&type=style&index=0&id=ab94e3f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab94e3f2"]])

export default __exports__